import Vue from "vue";
export default {
  isWeChatEnv() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /micromessenger/.test(userAgent);
  },
  //json参数转url
  urlCode(url, data) {
    let u = url;
    let n = 0;
    for (const param in data) {
      if (url.indexOf("?") < 0 && n == 0) {
        u += "?" + param + "=" + encodeURIComponent(data[param]);
      } else {
        u += "&" + param + "=" + encodeURIComponent(data[param]);
      }
      n++;
    }
    return u;
  },
  //格式化数字，用于页面输入限制
  formatFloat(ev, fixed = 2) {
    if (fixed == 0) {
      let reg = /^[0-9](\d+)?$/;
      if (!reg.test(ev.target.value)) {
        let reg2 = /^[0-9](\d+)?/;
        if (ev.target.value.match(reg2)) {
          ev.target.value = ev.target.value.match(reg2)[0];
        } else {
          ev.target.value = '';
        }
        ev.target._value = ev.target.value;
      }
      if (ev.target.value !== "") {
        return Number(ev.target.value);
      }
      return ev.target.value;
    } else {
      let reg = new RegExp("(^[1-9]([0-9]+)?(\\.[0-9]{1," + fixed + "})?$)|(^[0-9]\\.[0-9]([0-9]{0," + (fixed - 1) + "})?$)|(^(0){1}$)");
      let reg1 = new RegExp("^[0-9]+\\.{1}$");
      if (!reg.test(ev.target.value) && !reg1.test(ev.target.value)) {
        let reg2 = new RegExp("(^[1-9]([0-9]+)?(\\.[0-9]{1," + fixed + "})?)|(^[0-9]\\.[0-9]([0-9]{0," + (fixed - 1) + "})?)|(^(0){1})");
        if (ev.target.value.match(reg2)) {
          ev.target.value = ev.target.value.match(reg2)[0];
        } else {
          ev.target.value = '';
        }
        ev.target._value = ev.target.value;
      }
      return ev.target.value;
    }
  },
  //回退
  goBack() {
    window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
  },
  //设置session
  removeSession(key) {
    sessionStorage.removeItem(key);
  },
  //设置session
  setSession(key, value) {
    if (value instanceof Object) {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  },
  //获取ession
  getSession(key) {
    let value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  },
  // 设置cookie信息
  setCookie(key, value) {
    var Days = 30;   //cookie 将被保存30天
    var exp = new Date();  //获得当前时间
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);  //换成毫秒
    document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + exp.toGMTString();
    // if (value instanceof Object) {
    //   value = JSON.stringify(value);
    // }
    // localStorage.setItem(key, value);
  },
  // 删除cookie
  removeCookie(name) {
    this.setCookie(name, "");
    // localStorage.removeItem(name);
  },
  getEN(i) {
    return String.fromCharCode(i + 65);
  },
  // 获取cookie信息
  getCookie(key) {
    let cookieString = document.cookie;
    let arr = cookieString.split(';');
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
      let a = arr[i].split('=');
      obj[a[0].trim()] = a[1];
    }
    try {
      return JSON.parse(obj[key])
    } catch (e) {
      return obj[key] || ''
    }
    // let value = localStorage.getItem(key);
    // try {
    //   return JSON.parse(value)
    // } catch (e) {
    //   return value
    // }
  },
  //消息弹框
  message(type = "error", message, duration = 2000, showClose = true) {
    if (type == "success") {
      duration = 1000;
    }
    Vue.prototype.$notify({
      showClose,
      message,
      title: "消息提示",
      type,
      duration,
      offset: 40,
      position: "top-left",
      // center: true,
    });
  },
  toast(type, message, duration = 2000, config = {}) {
    if (type == "clear") {
      Vue.prototype.$toast.clear();
    } else {
      Vue.prototype.$toast({
        type,
        message,
        duration: type == "loading" ? 0 : duration,
        forbidClick: type == "loading" ? true : (config.forbidClick || false),
        position: type == "text" ? "bottom" : "middle",
      });
    }
  },
  // 获取用户信息
  getUserInfo() {
    // const pathname = location.pathname.replace(/\//g, "") || "ms";
    // var userInfo = this.getSession("userInfo");
    // if (pathname == "mb") {
    //   userInfo = this.getCookie("userInfo");
    // }
    var userInfo = this.getSession("userInfo");
    if (browser && browser.versions.mobile && !userInfo) {
      userInfo = this.getCookie("userInfo");
    }
    if (typeof userInfo != 'object' || !userInfo) {
      userInfo = {};
    }
    return userInfo;
  },
  //获取token
  getToken() {
    var userInfo = this.getUserInfo();
    if (userInfo && userInfo.token) {
      return (userInfo.token_type || "Bearer") + " " + userInfo.token
    }
    return "";
  },
  getTimestamp(date) {
    if (!date) {
      return new Date().getTime();
    }
    var time = this.formatDate(date, "yyyy/MM/dd HH:mm:ss");
    return new Date(time).getTime();
  },
  getNextDays(date, num, format) {
    var timestamp = this.getTimestamp(date) + num * 24 * 60 * 60 * 1000;
    return this.formatDate(timestamp, format);
  },
  getCutTime(type, times) {
    var h = parseInt(times / 60 / 60 % 24); //时
    h = h < 10 ? '0' + h : h;
    var m = parseInt(times / 60 % 60);
    m = m < 10 ? '0' + m : m;
    var s = parseInt(times % 60);
    s = s < 10 ? '0' + s : s;
    var cutTime = h + ":" + m + ":" + s;
    if (type == "m") {
      m = parseInt(m) + parseInt(h) * 60;
      m = m < 10 ? '0' + m : m;
      cutTime = m + ":" + s;
    }
    return cutTime;
  },
  //时间格式化
  formatDate(date, format, isMoment) {
    if (!date) return "";
    if (!format) format = "yyyy-MM-dd HH:mm:ss";
    var tagNum = /^[0-9]*$/.test(date);
    date = date + "";
    if (!tagNum && date.indexOf("T") < 0) {
      date = date.replace(/-/g, "/");
    }
    if (tagNum || Date.parse(date)) {
      if (tagNum) date = parseInt(date);
      date = new Date(date).getTime();
      if (date.toString().length == 10) {
        date = date * 1000;
      }
      let offest = new Date().getTimezoneOffset();
      if (isMoment) date = date - offest * 1000 * 60;
      let datetime = dateFtt(format, date);
      return datetime;
    } else {
      return date;
    }
    /**************************************时间格式化处理************************************/
    function dateFtt(fmt, date) { //author: meizz   
      var date = new Date(date);
      var o = {
        "M+": date.getMonth() + 1, //月份   
        "d+": date.getDate(), //日   
        "H+": date.getHours(), //小时   
        "m+": date.getMinutes(), //分   
        "s+": date.getSeconds(), //秒   
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
        "S": date.getMilliseconds() //毫秒   
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
  },
  base64() {
    // private property
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    // public method for encoding
    this.encode = function (input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = _utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
          _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
      }
      return output;
    }
    // public method for decoding
    this.decode = function (input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = _utf8_decode(output);
      return output;
    }

    // private method for UTF-8 encoding
    var _utf8_encode = function (string) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }

      }
      return utftext;
    }

    // private method for UTF-8 decoding
    var _utf8_decode = function (utftext) {
      var string = "";
      var i = 0;
      var c = c1 = c2 = 0;
      while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if ((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    }
  },
  blobToDataURI(blob, callback) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = function (e) {
      callback(e.target.result);
    };
  },
  //url到处文件
  exportExcel(url, target = '') {
    const alink = document.createElement('a');
    alink.style.display = 'none';
    alink.setAttribute("target", target);
    alink.href = url;
    document.body.appendChild(alink);
    alink.click();
    document.body.removeChild(alink);
  },
  //文件流下载
  fileDownload(data, excelName) {
    const blob = new Blob([data], { type: 'application/octet-stream' })
    const alink = document.createElement('a');
    alink.download = `${excelName}`;
    alink.href = URL.createObjectURL(blob);
    alink.click();
  },
  //去左右空格;
  trim(s) {
    return s.replace(/(^\s*)|(\s*$)/g, "");
  },
  //十六进制颜色转RGB
  hex2rgb(color) {
    if (!color) return false;
    color = color.substring(1);
    color = color.toLowerCase();
    let b = [];
    for (let x = 0; x < 3; x++) {
      b[0] = color.substr(x * 2, 2);
      b[3] = "0123456789abcdef";
      b[1] = b[0].substr(0, 1);
      b[2] = b[0].substr(1, 1);
      b[20 + x] = b[3].indexOf(b[1]) * 16 + b[3].indexOf(b[2]);
    }
    return [b[20], b[21], b[22]];
    // return "rgb(" +b[20]+","+b[21]+","+b[22]+ ")";
  },
  //保留小数点，只舍不入
  retainDecimal(num, fixed) {
    num = num + "";
    if (num.indexOf(".") < 0) {
      return num;
    }
    return num.substring(0, num.lastIndexOf('.') + (fixed + 1));
  },
  //深拷贝
  depCopy(obj) {
    try {
      return JSON.parse(JSON.stringify(obj))
    } catch (e) {
      return obj
    }
  },
  uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
      var r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join('');
  },
  parseQueryString(type) {
    var url = location.search;
    if (type === 'hash') {
      url = location.hash.substring(location.hash.indexOf("?"));
    }
    var query = {};
    if (url.indexOf("?") !== -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        try {
          query[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
        } catch (error) { }
      }
    }
    return query;
  },
  fileView(path, server) {
    if (!path) {
      return "";
    }
    if (server == "own") {
      return 'http://47.115.75.110:8012/onlinePreview?url=' + Base64.encode(path);
    } else {
      let target = ['.doc', '.xls', '.ppt'].find(item => path.indexOf(item) > 0);
      if (target) {
        return "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(path);
      } else {
        return path;
      }
    }
  },
  platform(value) {
    var platform = "";
    switch (value) {
      case "ms": platform = "管理端"; break;
      case "pc": platform = "电脑端"; break;
      case "mb": platform = "移动端"; break;
      default: platform = "其他";
    }
    return platform;
  },
  imageResize(url, w, h) {
    return `${url}?x-oss-process=image/resize,w_${w},h_${h}`
  },
  random(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  },
  getDateDays(date, cycle) {
    var obj = {
      date: date,
      // cycle,
      total: this.getDaysBetween(cycle.cycleStartTime, cycle.cycleEndTime),
      days: this.getDaysBetween(cycle.cycleStartTime, date),
    };
    obj.percent = Number((obj.days / obj.total * 100).toFixed(2));
    if (obj.percent < 0) {
      obj.percent = 0;
    }
    if (obj.percent > 100) {
      obj.percent = 100;
    }
    return obj;
  },
  getDaysInMonth(year, month) {
    let date = new Date(year, month, 1);
    return new Date(date.getTime() - 864e5).getDate();
  },
  getYearDays(year) {
    year = year || new Date().getFullYear();
    var isLeap = year % 4 == 0 && year % 100 != 0 || year % 400 == 0;
    return isLeap ? 366 : 365;
  },
  getDaysBetween(start, end) {
    var startDate = Date.parse(start);
    var endDate = Date.parse(end);
    if (startDate > endDate) {
      return 0;
    }
    // if (startDate==endDate){
    //     return 1;
    // }
    var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    return days;
  },
  getWeekNumber(dateString) {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    // 使用Date.UTC获取年初至今的毫秒数，并除以一周的毫秒数得到周数
    const startOfYear = new Date(Date.UTC(year, 0, 1));
    const startOfYearDay = startOfYear.getUTCDay() || 7; // 使用或运算符处理星期天的情况
    const weekNumber = Math.ceil(((date.getTime() - startOfYear.getTime()) / 86400000 + startOfYearDay - 1) / 7);
    return weekNumber;
  },
  fullScreen() {
    this.requestFullscreenFunName = null;
    this.exitFullscreenFunName = null;
    this.supprotFullScreen = false;
    let body = document.body;
    if (typeof body.requestFullscreen === 'function') {
      this.requestFullscreenFunName = 'requestFullscreen';
    } else if (typeof body.mozRequestFullScreen === 'function') {
      this.requestFullscreenFunName = 'mozRequestFullScreen';
    } else if (typeof body.msRequestFullscreen === 'function') {
      this.requestFullscreenFunName = 'msRequestFullscreen';
    } else if (typeof body.oRequestFullscreen === 'function') {
      this.requestFullscreenFunName = 'oRequestFullscreen';
    } else if (typeof body.webkitRequestFullscreen === 'function') {
      this.requestFullscreenFunName = 'webkitRequestFullscreen';
    }

    if (typeof document.exitFullscreen === 'function') {
      this.exitFullscreenFunName = 'exitFullscreen';
    } else if (typeof document.msExitFullscreen === 'function') {
      this.exitFullscreenFunName = 'msExitFullscreen';
    } else if (typeof document.mozCancelFullScreen === 'function') {
      this.exitFullscreenFunName = 'mozCancelFullScreen';
    } else if (typeof document.oRequestFullscreen === 'function') {
      this.exitFullscreenFunName = 'oRequestFullscreen';
    } else if (typeof document.webkitExitFullscreen === 'function') {
      this.exitFullscreenFunName = 'webkitExitFullscreen';
    }
    this.supprotFullScreen = (null !== this.requestFullscreenFunName && null !== this.exitFullscreenFunName);
    // 进入全屏
    this.enterFullscreen = function (element) {
      if (!this.supprotFullScreen) {
        return;
      }
      element[this.requestFullscreenFunName]();
    };
    // 退出全屏
    this.exitFullscreen = function () {
      if (!this.supprotFullScreen) {
        return;
      }
      document[this.exitFullscreenFunName]();
    }
  },
  stopMedia() {
    var timer = setTimeout(() => {
      var videos = document.getElementsByTagName("video");
      for (var i = 0; i < videos.length; i++) {
        videos[i].pause();
      }
      var audios = document.getElementsByTagName("audio");
      for (var i = 0; i < audios.length; i++) {
        audios[i].pause();
      }
      clearTimeout(timer);
    })
  },
  arseJwt(token) {
    // 分割JWT的三个部分
    let base64Url = token.split('.')[1];
    // 将Base64URL编码的载荷部分解码
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    // 解析载荷部分并返回
    return JSON.parse(jsonPayload);
  },
  calculateAge(birthDate) {
    birthDate = new Date(birthDate);
    var currentDate = new Date();
    var birthYear = birthDate.getFullYear();
    var birthMonth = birthDate.getMonth();
    var birthDayOfMonth = birthDate.getDate();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var currentDayOfMonth = currentDate.getDate();

    var age = currentYear - birthYear;
    if (currentMonth < birthMonth || (currentMonth == birthMonth && currentDayOfMonth < birthDayOfMonth)) {
      age--;
    }
    return age;
  },
  chartSize(val) {
    let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (!clientWidth) return;
    let percent = clientWidth / 1920;
    return val * percent;
  },
  hexToRgba(hex, opacity) {
    return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
  },
  getNationList() {
    return [
      {
        id: 1,
        name: '汉族',
        value: '汉族'
      },
      {
        id: 2,
        name: '壮族',
        value: '壮族'
      },
      {
        id: 3,
        name: '满族',
        value: '满族'
      },
      {
        id: 4,
        name: '回族',
        value: '回族'
      },
      {
        id: 5,
        name: '苗族',
        value: '苗族'
      },
      {
        id: 6,
        name: '维吾尔族',
        value: '维吾尔族'
      },
      {
        id: 7,
        name: '土家族',
        value: '土家族'
      },
      {
        id: 8,
        name: '彝族',
        value: '彝族'
      },
      {
        id: 9,
        name: '蒙古族',
        value: 9
      },
      {
        id: 10,
        name: '藏族',
        value: '藏族'
      },
      {
        id: 11,
        name: '布依族',
        value: '布依族'
      },
      {
        id: 12,
        name: '侗族',
        value: '侗族'
      },
      {
        id: 13,
        name: '瑶族',
        value: '瑶族'
      },
      {
        id: 14,
        name: '朝鲜族',
        value: '朝鲜族'
      },
      {
        id: 15,
        name: '白族',
        value: '白族'
      },
      {
        id: 16,
        name: '哈尼族',
        value: '哈尼族'
      },
      {
        id: 17,
        name: '哈萨克族',
        value: '哈萨克族'
      },
      {
        id: 18,
        name: '黎族',
        value: '黎族'
      },
      {
        id: 19,
        name: '傣族',
        value: '傣族'
      },
      {
        id: 20,
        name: '畲族',
        value: '畲族'
      },
      {
        id: 21,
        name: '傈僳族',
        value: '傈僳族'
      },
      {
        id: 22,
        name: '仡佬族',
        value: '仡佬族'
      },
      {
        id: 23,
        name: '东乡族',
        value: '东乡族'
      },
      {
        id: 24,
        name: '高山族',
        value: '高山族'
      },
      {
        id: 25,
        name: '拉祜族',
        value: '拉祜族'
      },
      {
        id: 26,
        name: '水族',
        value: '水族'
      },
      {
        id: 27,
        name: '佤族',
        value: '佤族'
      },
      {
        id: 28,
        name: '纳西族',
        value: '纳西族'
      },
      {
        id: 29,
        name: '羌族',
        value: '羌族'
      },
      {
        id: 30,
        name: '土族',
        value: '土族'
      },
      {
        id: 31,
        name: '仫佬族',
        value: '仫佬族'
      },
      {
        id: 32,
        name: '锡伯族',
        value: '锡伯族'
      },
      {
        id: 33,
        name: '柯尔克孜族',
        value: '柯尔克孜族'
      },
      {
        id: 34,
        name: '达斡尔族',
        value: '达斡尔族'
      },
      {
        id: 35,
        name: '景颇族',
        value: '景颇族'
      },
      {
        id: 36,
        name: '毛南族',
        value: '毛南族'
      },
      {
        id: 37,
        name: '撒拉族',
        value: '撒拉族'
      },
      {
        id: 38,
        name: '布朗族',
        value: '布朗族'
      },
      {
        id: 39,
        name: '塔吉克族',
        value: '塔吉克族'
      },
      {
        id: 40,
        name: '阿昌族',
        value: '阿昌族'
      },
      {
        id: 41,
        name: '普米族',
        value: '普米族'
      },
      {
        id: 42,
        name: '鄂温克族',
        value: '鄂温克族'
      },
      {
        id: 43,
        name: '怒族',
        value: '怒族'
      },
      {
        id: 44,
        name: '京族',
        value: '京族'
      },
      {
        id: 45,
        name: '基诺族',
        value: '基诺族'
      },
      {
        id: 46,
        name: '德昂族',
        value: '德昂族'
      },
      {
        id: 47,
        name: '保安族',
        value: '保安族'
      },
      {
        id: 48,
        name: '俄罗斯族',
        value: '俄罗斯族'
      },
      {
        id: 49,
        name: '裕固族',
        value: '裕固族'
      },
      {
        id: 50,
        name: '乌孜别克族',
        value: '乌孜别克族'
      },
      {
        id: 51,
        name: '门巴族',
        value: '门巴族'
      },
      {
        id: 52,
        name: '鄂伦春族',
        value: '鄂伦春族'
      },
      {
        id: 53,
        name: '独龙族',
        value: '独龙族'
      },
      {
        id: 54,
        name: '塔塔尔族',
        value: '塔塔尔族'
      },
      {
        id: 55,
        name: '赫哲族',
        value: '赫哲族'
      },
      {
        id: 56,
        name: '珞巴族',
        value: '珞巴族'
      }
    ]
  },
  //计算地图坐标距离
  gpsDistance(p1, p2) {
    var lat1 = _angle2rad(p1[1]);
    var lat2 = _angle2rad(p2[1]);
    var a = lat1 - lat2;
    var b = _angle2rad(p1[0]) - _angle2rad(p2[0]);
    var distance = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2)
      + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(b / 2), 2)));
    return distance * 6378137;
  },
  timestampToHour(timestamp) {
    // 将时间戳转换为Date对象
    var date = new Date(timestamp);

    // 设置分钟和秒数为0
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    // 返回整点时间戳
    return date.getTime();
  },
  getDateWeek(date, prefix = "星期") {
    var arr = ["日", "一", "二", "三", "四", "五", "六"];
    var num = new Date(this.formatDate(date, "yyyy/MM/dd")).getDay();
    return prefix + arr[num];
  },
  tenantType(val) {
    var name = "";
    switch (val) {
      case 1: name = "企业"; break;
      case 2: name = "中职"; break;
      case 3: name = "高职"; break;
      case 4: name = "专科"; break;
      case 5: name = "本科"; break;
      default: name = "单位"; break;
    }
    return name;
  },
}



// WEBPACK FOOTER //
// ./src/utils/func.js